import { defaultURL } from '@common/constants/shared';
import { ImagePicker } from '@common/utils/upload';
import { get, isEmpty, isString, isUndefined } from 'lodash';
import React, { FC, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { localeSelector } from '@common/redux/selectors/language';
import {
  ActivityIndicator,
  Platform,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';
import connectorInput from '../ConnectorInput';
import createStyles, { staticStyles } from './style';
import ImageIcon from '../Icons/ImageIcon';
import { appInfoSelector } from '@common/redux/selectors/app';
import { ImageBackgroundSecurity } from '@common/components/ImageSecurity/ImageBackgroundSecurity';

const InputError = ({ errorMessage }: { errorMessage?: string | null }) => {
  if (!errorMessage) return null;
  return (
    <Text
      style={{
        color: 'red',
        fontSize: 12,
        left: 4,
        bottom: 0,
        position: 'absolute',
      }}
    >
      {errorMessage}
    </Text>
  );
};
const CusImageUpload: FC<any> = (attributes) => {
  const locale = useSelector(localeSelector);
  const appInfo = useSelector(appInfoSelector);
  const { placeholder, valueInput, changeInput, inputError } = attributes;
  const [initialized, setInitialized] = useState(false);

  const [error, setError] = useState('');

  const styles = createStyles(attributes);

  const [pending, setPending] = useState(false);
  const isPlaceholderImage =
    placeholder?.placeholderImage && placeholder?.placeholderImageEnabled;
  const imageResize = attributes.defaultValue?.imageResize ?? 'cover';
  const useFileSecurity = true;

  const handlePress = () => {
    const imageCompress = isUndefined(placeholder?.imageCompress)
      ? true
      : placeholder?.imageCompress;

    if (Platform.OS !== 'web') return;
    setPending(true);
    error && setError('');
    ImagePicker.showImagePicker(
      {
        quality: 0.7,
        setPending,
        imageUpload: true,
        setError,
        attributes: {
          ...(attributes || {}),
          useFileSecurity,
        },
        imageCompress,
      },
      (response: any) => {
        if (response?.url) {
          setPending(false);
          changeInput(response);
        }
      },
      appInfo?.workspaceId
    );
  };

  const Loading = () => {
    if (!pending) return null;
    return (
      <View>
        <ActivityIndicator />
        <Text style={{ color: 'white' }}>Uploading...</Text>
      </View>
    );
  };

  const uri =
    error && isPlaceholderImage
      ? placeholder.placeholderImage
      : error
      ? defaultURL
      : isString(valueInput)
      ? valueInput
      : get(valueInput, 'url');

  useEffect(() => {
    // when attributes.data is not empty, update inputValue with defaultValue
    if (attributes.data) {
      if (initialized) {
        return;
      }
      setInitialized(true);
      // update inputValue when default value is not empty
      if (attributes.data?.defaultValue) {
        changeInput(attributes.data?.defaultValue);
        return;
      }
      changeInput(null);
    }
  }, [attributes.data, initialized]);

  if (!isEmpty(uri)) {
    return (
      <React.Fragment>
        <View style={styles.innerWrapper}>
          <TouchableOpacity onPress={handlePress} style={{ flex: 1 }}>
            <View style={styles.preview}>
              <ImageBackgroundSecurity
                style={[
                  staticStyles.previewImage,
                  pending ? staticStyles.faded : {},
                ]}
                source={{
                  uri,
                }}
                resizeMode={imageResize === 'contain' ? 'contain' : 'cover'}
                onError={({ nativeEvent }: any) => {
                  setError(nativeEvent?.error);
                }}
              />
              <Loading />
            </View>
          </TouchableOpacity>
          <InputError errorMessage={inputError} />
        </View>
      </React.Fragment>
    );
  }
  return (
    <React.Fragment>
      <View style={styles.innerWrapper}>
        <ImageBackgroundSecurity
          source={{
            uri: isPlaceholderImage ? placeholder.placeholderImage : null,
          }}
          resizeMode={imageResize === 'contain' ? 'contain' : 'cover'}
          style={staticStyles.image}
        >
          <TouchableOpacity
            style={staticStyles.emptyWrapper}
            onPress={handlePress}
          >
            <Loading />
            <ImageIcon />

            {!valueInput && !pending && (
              <Text style={staticStyles.text}>
                写真の選択
                {/* {locale === 'ja' ? '写真の選択' : 'Choose Photo'} */}
              </Text>
            )}
          </TouchableOpacity>
        </ImageBackgroundSecurity>
        <InputError errorMessage={inputError} />
      </View>
    </React.Fragment>
  );
};

export default connectorInput(CusImageUpload);
